import './vendor/History'
import Helpers from '../modules/Helpers'
import Reveal from '../modules/Reveal'
import XHRPromise from 'xhr-promise'
import breadcrumbs from '../modules/Breadcrumbs'

const history = window.History

const blog = {};

blog.state = {};
blog.nav = {};
blog.ui = {};


blog.state.baseUrl = '/nas';
blog.state.page = 1;

blog.state.getURL = (page) => {
    if(page==undefined) page = blog.state.page;
    // get category & location parameters
    let catUrl = '/' + blog.nav.getCategory()
    let locUrl = '/' + blog.nav.getLocation()
    if (locUrl.indexOf('the-west-country') !== -1 || locUrl == '/') locUrl = ''

    // build querystring for ordering & pagination
    let qs = '';
    if (blog.nav.getSort() == 'P') {
        qs = (qs.length ? '&' : '?') + 's=popular'
    }
    if (page > 1) {
        qs = (qs.length ? '&' : '?') + 'page=' + page
    }

    // build complete url
    let fullUrl;
    if (locUrl == '' && catUrl == '/latest') {
        fullUrl = blog.state.baseUrl + '/' + qs
    } else {
        fullUrl = blog.state.baseUrl + catUrl + locUrl + '.html' + qs
    }
    return fullUrl;
}


blog.state.readUI = (page) => {
    if (page != undefined) blog.state.page = page

    const fullUrl = blog.state.getURL()
    if (blog.nav.isInteractive()) {
        // push new page into history and run ajax load
        const params = {
            category: blog.nav.getCategory(),
            location: blog.nav.getLocation(),
            sort: blog.nav.getSort(),
            page: blog.state.page
        }

        history.pushState(params, document.title, fullUrl)
    } else {
        // modify the href action of the search link
        document.getElementById('blogSearch').href= fullUrl
    }
}

blog.state.setUI = (state) => {
    blog.nav.setCategory(state.category === '' ? 'latest' : state.category)
    blog.nav.setLocation(state.location === '' ? '' : state.location)
    blog.nav.setSort(state.sort === '' ? 'L' : state.sort)
};

blog.state.init = () => {
    history.Adapter.bind(window, 'statechange', (e) => {
        const state = history.getState().data
        blog.state.setUI(state)
        blog.nav.search(state)
        window.dataLayerQueue.push({ 'event': 'pageView' });
    })
}



blog.nav.categoryLinks = Array.from(document.querySelectorAll('#blogCategories a'))
blog.nav.locationLinks = Array.from(document.querySelectorAll('#blogLocations a'))
blog.nav.sortLinks = Array.from(document.querySelectorAll('#blogOrder button'))


blog.nav.init = function () {
    // click event trigger on category
    new Helpers(blog.nav.categoryLinks).eventListener((e) => {
        e.preventDefault()
        e.stopPropagation()
        blog.nav.setCategory(e.target.getAttribute('data-code'))
        blog.state.readUI(1)
        blog.nav.hideAccordions()
    })
    
    // click event trigger on location
    new Helpers(blog.nav.locationLinks).eventListener((e) => {
        e.preventDefault()
        e.stopPropagation()
        blog.nav.setLocation(e.target.getAttribute('data-code'))
        blog.state.readUI(1)
        blog.nav.hideAccordions()
    })

    // click event trigger on sort
    new Helpers(blog.nav.sortLinks).eventListener((e) => {
        e.preventDefault()
        blog.nav.setSort(e.target.getAttribute('data-code'))
        blog.state.readUI(1)
        blog.nav.hideAccordions()
    })

    new Helpers(document.getElementsByTagName('body')).eventListener((e) => {
        blog.nav.hideAccordions(e.target.id)
    })
};

blog.nav.isInteractive = () => {
    return document.getElementById('blogSearch') === null
}

blog.nav.hideAccordions = (excludeId = '') => {
    if (excludeId !== 'blogCategory') {
        new Helpers(document.getElementById('blogCategory')).removeClass('accordion-toggle--active')
        new Reveal(document.getElementById('blogCategories')).hide('accordion--active')
    }
    if (excludeId !== 'blogLocation') {
        new Helpers(document.getElementById('blogLocation')).removeClass('accordion-toggle--active')
        new Reveal(document.getElementById('blogLocations')).hide('accordion--active')
    }
    if (excludeId !== 'blogSort' && document.getElementById('blogSort') !== null) {
        new Helpers(document.getElementById('blogSort')).removeClass('accordion-toggle--active')
        new Reveal(document.getElementById('blogOrder')).hide('accordion--active')
    }
}

blog.nav.getCategory = () => {
    let category = ""
    blog.nav.categoryLinks.forEach((a) => {
        if (a.getAttribute('aria-current') == 'true') {
            category = a.getAttribute('data-code')
        }
    });
    return category
}

blog.nav.setCategory = (category) => {
    blog.nav.categoryLinks.forEach((c) => {
        if (c.getAttribute('data-code') === category) {
            // set as current and set button text from link
            c.setAttribute('aria-current', 'true')
            document.getElementById('blogCategory').innerText = c.innerText
        } else {
            c.setAttribute('aria-current', 'false')
        }
    })
};

blog.nav.getLocation = () => {
    let location = ""
    blog.nav.locationLinks.forEach((a) => {
        if (a.getAttribute('aria-current') == 'true') {
            location = a.getAttribute('data-code')
        }
    });
    return location
}

blog.nav.setLocation = (location) => {
    blog.nav.locationLinks.forEach((l) => {
        if (l.getAttribute('data-code') === location) {
            // set as current and set button text from link
            l.setAttribute('aria-current', 'true')
            document.getElementById('blogLocation').innerText = l.innerText
        } else {
            l.setAttribute('aria-current', 'false')
        }
    })
};

blog.nav.getSort = () => {
    let sort = ""
    blog.nav.sortLinks.forEach((a) => {
        if (a.getAttribute('aria-current') == 'true') {
            sort = a.getAttribute('data-code')
        }
    });
    return sort
}

blog.nav.setSort = (sort) => {
    blog.nav.sortLinks.forEach((s) => {
        s.setAttribute('aria-current', s.getAttribute('data-code') === sort)
    })
}


blog.nav.pagination = (total) => {
    const link = document.getElementsByClassName('blog-main__load-more-toggle')[0]
    const maxPage = Math.ceil(total / 8)
    const nextPage = blog.state.page + 1

    link.href = blog.state.getURL(blog.state.page + 1)
    link.setAttribute('aria-hidden', nextPage > maxPage)
}

blog.loading = {}
blog.loading.earliest = null
blog.loading.start = () => {
    const filter = document.getElementsByClassName('filter')[0]
    new Helpers(filter).removeClass('filter--loading')
    void filter.offsetWidth
    new Helpers(filter).addClass('filter--loading')
    blog.loading.earliest = new Date(new Date().getTime() + 2000).getTime();
}

blog.loading.stop = () => {
    if (blog.loading.earliest === null || blog.loading.earliest <= new Date().getTime()) {
        const filter = document.getElementsByClassName('filter')[0]
        new Helpers(filter).removeClass('filter--loading')
    } else {
        setTimeout(blog.loading.stop, blog.loading.earliest - new Date().getTime())
    }
}



blog.nav.fetch = -1
blog.nav.search = (state) => {

    if (blog.nav.fetch !== -1) {
        blog.nav.fetch.getXHR().abort()
        blog.nav.fetch = -1
    }

    blog.loading.start()

    blog.nav.fetch = new XHRPromise()

    blog.nav.fetch.send({
        url: `/nas/feed.aspx?category=${state.category}&location=${state.location}&sort=${state.sort}&page=${state.page}`
    })
    .then((response) => {
        return response.responseText
    })
    .then((data) => {
        blog.ui.updateList(data.Articles);
        blog.ui.total(data.Total);
        blog.ui.intro(data.Intro);
        blog.nav.pagination(data.Total);
        breadcrumbs.set(data.Breadcrumbs)
        blog.nav.fetch = -1
        blog.loading.stop()
        document.title = data.MetaTitle
    })
};



blog.nav.loadMore = () => {

    if (blog.nav.fetch !== -1) {
        blog.nav.fetch.getXHR().abort()
        blog.nav.fetch = -1
    }

    blog.nav.fetch = new XHRPromise()

    blog.nav.fetch.send({
        url: `/nas/feed.aspx?category=${blog.nav.getCategory()}&location=${blog.nav.getLocation()}&sort=${blog.nav.getSort()}&page=${blog.state.page}`,
    })
    .then((response) => {
        return response.responseText
    })
    .then((data) => {
        blog.ui.addToList(data.Articles);
        blog.nav.pagination(data.Total)
        blog.nav.fetch = -1
    })
}


blog.ui.init = function () {
    const showMoreEl = document.getElementsByClassName('blog-main__load-more-toggle')[0]
    new Helpers(showMoreEl).eventListener((e) => {
        e.preventDefault()
        if (blog.nav.fetch === -1) {
            blog.ui.lazyLoad()
        }
    })
    this.showMoreRunInterval = setInterval(() => {
        if (new Helpers(showMoreEl).isInViewport()) {
            // if button is visible (if not then no more results)
            // and not already running
            if (showMoreEl.getAttribute('aria-hidden') == 'false' && blog.nav.fetch === -1) {
                blog.ui.lazyLoad()
            }
        }
    }, 200)

    blog.ui.inlineTweets()
};

blog.ui.lazyLoadEnabled = true;
blog.ui.lazyLoad = () => {
    blog.state.page++;
    blog.nav.loadMore();
}


blog.ui.total = (total) => {
    document.getElementsByClassName('filter__no-articles')[0].innerText = total + ' articles'
};

blog.ui.intro = (intro) => {
    document.getElementsByClassName('blog-main__header')[0].innerHTML = intro
};

blog.ui.updateList = (articles) => {
    document.getElementsByClassName('blog-main__article-group')[0].innerHTML = ''
    blog.ui.addToList(articles)
}

blog.ui.addToList = (articles) => {

    articles.forEach((a) => {
        const article = `<article class="blog-main__article-item" data-id="${a.Id}" data-pop="${a.Popularity}" data-ticks="${a.Ticks}">
                <a href="${a.Url}">
                    <img src="${a.Img}">
                </a>
                <h4><a href="${a.Url}">${a.Title}</a></h4>
                <p>${a.Teaser}</p>
                <small class="blog-main__category">${a.Category.Title}</small>
                <small class="blog-main__info"><span>${a.DatePosted}</span> ${a.Author}</small>`

        // TODO: do something with these articles
        const el = document.createElement('div')
        el.innerHTML = article
        document.getElementsByClassName('blog-main__article-group')[0].appendChild(el.firstChild)
    })
}

blog.ui.inlineTweets = function () {
    new Helpers(document.getElementsByClassName('')).eventListener((e) => {
        var text = e.target.innerText
        window.open('https://twitter.com/intent/tweet?text=' + text + ' ' + window.location.href + '&via=classiccottages&related=classiccottages', 'ArticleTweet', 'width=600,height=400')
    })
};



if (new Helpers(document.getElementsByTagName('body')).hasClass('blog')) {
    blog.nav.init();


    if (document.getElementsByClassName('blog-main__article-group').length) {
        blog.ui.init();
        blog.state.init();
    }
}